import React, { useState } from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';
import SkipToContent from './SkipToContent';

const Main = styled.main`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  padding-top: 88px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 72px;
  }
`;

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <SkipToContent />
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Main id="main-content" tabIndex={-1}>
        {children}
      </Main>
      <Footer />
    </>
  );
};

export default Layout;
